export interface ImageSchemaInput {
    name: string
    description?: string
    contentUrl?: string
    thumbnailUrl?: string
    mainEntityOfPage?: string
    encodingFormat?: string
}

export function buildImageObject(
    input: ImageSchemaInput
): Record<string, any> | null {
    const name = input.name?.trim()
    const contentUrl = input.contentUrl?.trim()

    if (!name || !contentUrl) {
        return null
    }

    const description = (input.description || input.name).trim()
    const thumbnailUrl = input.thumbnailUrl?.trim() || contentUrl

    const imageObject: Record<string, any> = {
        '@context': 'https://schema.org',
        '@type': 'ImageObject',
        name,
        description,
        contentUrl,
        url: contentUrl,
        representativeOfPage: true,
    }

    if (thumbnailUrl) {
        imageObject.thumbnail = {
            '@type': 'ImageObject',
            contentUrl: thumbnailUrl,
            url: thumbnailUrl,
        }
    }

    if (input.encodingFormat) {
        imageObject.encodingFormat = input.encodingFormat
    }

    if (input.mainEntityOfPage) {
        imageObject.mainEntityOfPage = input.mainEntityOfPage
    }

    return imageObject
}
